import React from 'react';
import { EB_LIMIT } from '../constants';
import { IExtractionBatch } from '../types/my-types';
import { TSetExtractionBatch } from '../types/util';
export interface IExtractionContext {
  ebOffSet: number;
  setEbOffSet: (value: number) => void;
  extractionBatch: IExtractionBatch | null;
  setExtractionBatch: (value: TSetExtractionBatch) => void;
  classifierOn: boolean;
  setClassifierOn: (value: boolean) => void;
  groupKey: string;
  setGroupKey: (value: string) => void;
}

export const ExtractionContext = React.createContext({} as IExtractionContext);

export const ExtractionContextProvider = ({ children }: any) => {
  const [ebOffSet, setEbOffSet] = React.useState(0);
  const [classifierOn, setClassifierOn] = React.useState(false);
  const [extractionBatch, setExtractionBatch] = React.useState(null);
  const [groupKey, setGroupKey] = React.useState('');

  return (
    <ExtractionContext.Provider
      value={{
        ebOffSet,
        setEbOffSet,
        extractionBatch,
        setExtractionBatch,
        classifierOn,
        setClassifierOn,
        groupKey,
        setGroupKey,
      }}
    >
      {children}
    </ExtractionContext.Provider>
  );
};
